import Monaco, { OnChange } from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/components/Monaco'
import proxyAction from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/globalActions/proxy.json'
import useDatasource from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/hooks/useDatasource'
import useSearchParams from '@/pages/SpaceAppBuilder/DataSourcesBuilderPage/hooks/useSearchParams'

export function Perform() {
  const [datasource, setDatasource] = useDatasource(true)

  const datasourceEventActions: typeof datasource.events = { _proxy: proxyAction, ...datasource.events }

  const [searchParams] = useSearchParams()

  const activeEventActionKey = searchParams.get('eventAction')!

  const handlePerformChange: OnChange = (value = '') => {
    if (!activeEventActionKey) return

    setDatasource(datasource => ({
      ...datasource,
      events: {
        ...datasource.events,
        [activeEventActionKey]: {
          ...(activeEventActionKey === '_proxy' ? proxyAction : {}),
          ...datasource.events[activeEventActionKey],
          perform: value
        }
      }
    }))
  }

  return (
    <div className="flex flex-1 flex-col">
      <div className="bg-gray-100 px-4 py-2 text-xs">Perform</div>
      <Monaco
        key={activeEventActionKey}
        language="typescript"
        showBeautifyButton={true}
        defaultValue={datasourceEventActions[activeEventActionKey].perform}
        onChange={handlePerformChange}
      />
    </div>
  )
}
